import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getCancellationCouponStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.CANCELLATION_COUPON);

export default getCancellationCouponStatus;
